import React, { useState, useCallback } from 'react'
import { useDropzone } from 'react-dropzone'

const Uploader = ({ uploadDone, url, supplierId, children }) => {

  const [uploadingFiles, setUploadingFiles] = useState(false)

  const onFileDrop = useCallback((acceptedFiles) => {
    setUploadingFiles(true)

    const promises = acceptedFiles.map((file) => {
      const body = new FormData()
      body.append('file', file)
      return fetch(url, { method: 'POST', body })
    })

    Promise.all(promises)
      .then(() => setUploadingFiles(false))
      .then(uploadDone)
      .catch((error) => window?.toastr.error(error))
  }, [supplierId])

  const { acceptedFiles, getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop: onFileDrop, maxSize: 50000000 })

  return (
    <div className="pull-right" {...getRootProps()}>
      <div>
        <input {...getInputProps()} />
        {
          uploadingFiles ?
            <p>Uploading files..</p>
              : isDragActive ?
                <p>Drop the files here ...</p>
                :
                <div className="pull-right">
                  {children}
                </div>
        }
      </div>
    </div>
  )
}

export default Uploader

